import styled from "styled-components";

export const SubscriptionBreakdownContainer = styled.div`
  display: none;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 1rem 1rem 2rem 1rem;
  color: #a9a9a9;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  margin-bottom: 2rem;

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    padding: 1rem 2rem 2rem 2rem;
  }

  /* Desktop styles: 1024px and up */
  @media (min-width: 1024px) {
    padding: 1rem 2rem 2rem 2rem;
  }
`;

export const SubscriptionBreakdownHeader = styled.div`
  font-size: 1.5rem;
  text-align: center;
  padding-bottom: 0.5rem;
  width: 100%;
  font-weight: 700;
  color: #3b5eab;

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    font-size: 1.75rem;
  }

  /* Desktop styles: 1024px and up */
  @media (min-width: 1024px) {
    font-size: 2rem;
  }
`;

export const LineItemContainer = styled.div`
  width: 100%;
  max-width: 320px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    max-width: 400px;
  }

  /* Desktop styles: 1024px and up */
  @media (min-width: 1024px) {
    width: 30rem;
    max-width: none;
  }
`;

export const LineItem = styled.div`
  font-size: 1rem;
  padding: 0.25rem 0.5rem 0.25rem 0;
  text-align: left;
  flex: 1;
  line-height: 1.4;

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    font-size: 1.25rem;
    padding: 0.5rem;
  }

  /* Desktop styles: 1024px and up */
  @media (min-width: 1024px) {
    font-size: 1.5rem;
  }
`;

export const LineItemValue = styled.div`
  font-size: 1rem;
  padding: 0.25rem 0 0.25rem 0.5rem;
  text-align: right;
  flex-shrink: 0;
  line-height: 1.4;
  font-weight: 600;

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    font-size: 1.25rem;
    padding: 0.5rem;
  }

  /* Desktop styles: 1024px and up */
  @media (min-width: 1024px) {
    font-size: 1.5rem;
  }
`;

export const SecondaryLineItem = styled.div`
  font-size: 1rem;
  padding-left: 1rem;
  text-align: left;
  flex: 1;
  line-height: 1.4;
  opacity: 0.8;

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    font-size: 1.25rem;
    padding-left: 2rem;
  }

  /* Desktop styles: 1024px and up */
  @media (min-width: 1024px) {
    font-size: 1.5rem;
    padding-left: 3rem;
  }
`;
